"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { shopifyFeatureServices, ShopifyFeatureServiceCard } from "./shopify.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface ShopifyFeatureServicesProps {
  heading?: string;
  subtitle?: string;
  services?: ShopifyFeatureServiceCard[];
  className?: string;
}
export default function ShopifyFeatureServices(t0) {
  const $ = _c(32);
  const {
    heading: t1,
    subtitle: t2,
    services: t3,
    className: t4
  } = t0;
  const heading = t1 === undefined ? "Hire our Shopify Developers for End-to-End Services" : t1;
  const subtitle = t2 === undefined ? "Bring your business to the online market in full fledge with custom Shopify development services from The Dezine. Hire pre-vetted Shopify experts to leverage their years of business expertise in developing custom Shopify solutions for your business." : t2;
  const services = t3 === undefined ? shopifyFeatureServices : t3;
  const className = t4 === undefined ? "" : t4;
  const desktopAnimations = useDesktopAnimations();
  const t5 = `relative overflow-hidden bg-white py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#070b14] ${className}`;
  let t6;
  if ($[0] !== desktopAnimations) {
    t6 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[0] = desktopAnimations;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== desktopAnimations) {
    t7 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== desktopAnimations) {
    t8 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t10;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      once: true
    };
    t10 = {
      duration: 0.7,
      ease
    };
    $[6] = t10;
    $[7] = t9;
  } else {
    t10 = $[6];
    t9 = $[7];
  }
  let t11;
  if ($[8] !== heading || $[9] !== t6 || $[10] !== t7 || $[11] !== t8) {
    t11 = <motion.h2 initial={t6} whileInView={t7} animate={t8} viewport={t9} transition={t10} className="font-poppins mb-5 text-[28px] font-bold leading-[1.2] tracking-tight text-[#0b1354] sm:text-[36px] lg:text-[42px] dark:text-white">{heading}</motion.h2>;
    $[8] = heading;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== desktopAnimations || $[14] !== subtitle) {
    t12 = subtitle && <motion.p initial={desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7,
      delay: 0.1,
      ease
    }} className="mx-auto max-w-[860px] font-sans text-[15px] font-normal leading-[1.75] text-[#5b6b7d] sm:text-[16px] dark:text-gray-400">{subtitle}</motion.p>;
    $[13] = desktopAnimations;
    $[14] = subtitle;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11 || $[17] !== t12) {
    t13 = <div className="mx-auto mb-14 max-w-4xl text-center md:mb-18">{t11}{t12}</div>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== desktopAnimations || $[20] !== services) {
    let t15;
    if ($[22] !== desktopAnimations) {
      t15 = (service, idx) => <motion.div key={service.id} initial={desktopAnimations ? {
        opacity: 0,
        y: 35
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: idx * 0.12,
        ease
      }} className="flex h-full"><article className="group relative flex w-full flex-col overflow-hidden rounded-[24px] border border-gray-100/80 bg-white shadow-[0_8px_30px_rgba(20,50,90,0.06)] transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_20px_45px_rgba(20,50,90,0.12)] dark:border-gray-800 dark:bg-gray-900"><div className={`relative flex min-h-[210px] sm:min-h-[230px] items-center justify-center p-6 transition-colors duration-300 ${service.topGradient || "bg-gradient-to-b from-[#f7efff] to-[#fdeff8] dark:from-purple-950/30 dark:to-pink-950/20"}`}><Image src={service.image} alt={service.alt} width={280} height={175} loading="lazy" className="max-h-[160px] sm:max-h-[175px] w-auto max-w-[88%] object-contain drop-shadow-sm transition-transform duration-500 ease-out group-hover:scale-105" /></div><div className="flex flex-1 flex-col p-7 sm:p-8"><h3 className="font-poppins mb-2.5 text-[20px] sm:text-[22px] font-bold leading-[1.3] text-[#0b1354] dark:text-white">{service.title}</h3><p className="font-sans mb-6 text-[14.5px] sm:text-[15px] font-normal leading-[1.6] text-[#5e6282] dark:text-gray-300">{service.subtitle}</p><ul className="mt-auto space-y-3 font-sans text-[14px] sm:text-[14.5px] leading-[1.6] text-[#5e6282] dark:text-gray-300">{service.points.map(_temp)}</ul></div></article></motion.div>;
      $[22] = desktopAnimations;
      $[23] = t15;
    } else {
      t15 = $[23];
    }
    t14 = services.map(t15);
    $[19] = desktopAnimations;
    $[20] = services;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[24] !== t14) {
    t15 = <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 lg:gap-9">{t14}</div>;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t15) {
    t16 = <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">{t13}{t15}</div>;
    $[26] = t13;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t16 || $[30] !== t5) {
    t17 = <section className={t5}>{t16}</section>;
    $[29] = t16;
    $[30] = t5;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
}
function _temp(point, pointIdx) {
  return <li key={pointIdx} className="flex items-start gap-2.5"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#5e6282] dark:bg-gray-400" /><span>{point}</span></li>;
}